import React from 'react';
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';

import Typography from '@mui/material/Typography';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';

import Header from "./common/Header2";

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  	...theme.typography.body2,
  	padding: theme.spacing(1),
  	textAlign: 'center',
  	color: theme.palette.text.secondary,
}));

function StartContent(props) {

  	let navigate = useNavigate(); 
	const { t, i18n } = useTranslation("",{lng: props.language});


	const callUrl = (url) => {
		navigate(url);
	};
	
	const [ref0, inView0] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref1, inView1] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref2, inView2] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});	
	
	const [ref3, inView3] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const hero = [ {
	  	"src": "Slide1HeroVerkaufPage",
		"headline": t("ImmobilienClaim1"),
		"slogan": "Slogan fehlt hier"
		}
	];


  	return (<>
	  			<Box>
					<Header hero={hero} embedded={props.props.embedded} logo="logo-verkauf.png"/>
	  			</Box>
  				<Box sx={{ display: {
																		xs: 'block',
																		sm: 'block',  
																		md: 'none',  
																		lg: 'none',  
																		xl: 'none',  																		
																		}}}
				> 
					<center>
						<h2 style={{paddingTop: "4px", fontSize: "1.5em"}} class="headlineNewPoint">{t("Sie möchten Ihre Immobilie anbieten?")}</h2>
					</center>
	      			<Grid container style={{paddingTop: "4px"}}>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={1}>
					     		</Grid>
			        			<Grid item xs={10}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}}>
										<Box  style={{color: "#000"}}>					
											<Box sx={{paddingLeft: "0px"}} >											        
										        <Typography variant="body2" color="text.secondary" sx={{fontSize: "1.2em"}}>
													<ul class="empty" sx={{listStyleType: "none"}}>
														<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP1")}</li>
														<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP2")}</li>
														<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP3")}</li>
														<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP4")}</li>
														<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP5")}</li>
													</ul>											        			
										        </Typography>
											</Box>			
										</Box>			
									</Box>	
				     	   		</Grid>					
			        			<Grid item xs={1}>
					     		</Grid>
			     	   		</Grid>					
		     	   		</Grid>										
		     	   	</Grid>										
	      			<Grid container style={{paddingTop: "4px"}}>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={1}>
					     		</Grid>
			        			<Grid item xs={10} sx={{	display: "flex",
															flexDirection: "row",
															justifyContent: "end",
															alignItems: "flex-end"}}
										>
											<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
												<Box  style={{textAlign: "justify", color: "#000"}}>					
													<p class="altFliessText" style={{margin: 0}}>{t("immobilienverkaufContent")}</p>
												</Box>			
											</Box>	
						     	   		</Grid>
			
			        			<Grid item xs={1}>
					     		</Grid>
			     	   		</Grid>					
		     	   		</Grid>										
		     	   	</Grid>										
					<center>
						<h2 style={{paddingTop: "40px", fontSize: "1.5em"}} class="headlineNewPoint">{t("Unsicher was Ihre Immobilie wert ist?")}</h2>
					</center>

	      			<Grid container style={{paddingTop: "4px"}}>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={1}>
					     		</Grid>
			        			<Grid item xs={10} sx={{	display: "flex",
															flexDirection: "row",
															justifyContent: "end",
															alignItems: "flex-end"}}
										>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000", paddingBottom: "20px"}}>					
											<p class="altFliessText" style={{margin: 0}}>{t("immobilienverkaufBewertung")}</p>
										</Box>
										<center>		
										<Button onClick={e => callUrl("/immobilienbewertung")} variant="contained">Informieren</Button>                	
										</center>		

									</Box>	
						     	   		</Grid>
			
			        			<Grid item xs={1}>
					     		</Grid>
			     	   		</Grid>					
		     	   		</Grid>										
		     	   	</Grid>

				</Box>	  			
	  			
				<Box sx={{ flexGrow: 1, display: {
							xs: 'none',
							sm: 'block',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  							
							} }}
				>
				<hr className="spacer"/>
					<center>
						<h2 style={{paddingTop: "40px"}} class="headlineNewPoint">{t("Sie möchten Ihre Immobilie anbieten?")}</h2>
					</center>
				
	  					<Box sx={{paddingTop: "0px", marginTop: "40px"}}> 
			      			<Grid container style={{paddingTop: "40px"}}>
			        			<Grid item xs={12}>
					      			<Grid container spacing={2}>
					        			<Grid item xs={1}>
							     		</Grid>
					        			<Grid item xs={5}>
											<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}}>
												<Box  style={{color: "#000"}}>					
													<Box sx={{paddingLeft: "50px"}} >											        
												        <Typography variant="body2" color="text.secondary" sx={{fontSize: "1.2em"}}>
															<ul class="empty" sx={{listStyleType: "none"}}>
																<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP1")}</li>
																<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP2")}</li>
																<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP3")}</li>
																<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP4")}</li>
																<li><CheckIcon sx={{fontSize: "1.5em", color: "#163e64"}}/>{t("immobilienverkaufUSP5")}</li>
															</ul>											        			
												        </Typography>
													</Box>			
												</Box>			
											</Box>	
						     	   		</Grid>
					        			<Grid item xs={5} sx={{	display: "flex",
															flexDirection: "row",
															justifyContent: "end",
															alignItems: "flex-end"}}
										>
											<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
												<Box  style={{textAlign: "justify", color: "#000"}}>					
													<p class="altFliessText" style={{margin: 0}}>{t("immobilienverkaufContent")}</p>
												</Box>			
											</Box>	
						     	   		</Grid>
						        		<Grid item xs={1}>
							     		</Grid>
					     	   		</Grid>
				     	   		</Grid>
			     	   		</Grid>
						<center>
							<h2 style={{paddingTop: "40px"}} class="headlineNewPoint">{t("Unsicher was Ihre Immobilie wert ist?")}</h2>
						</center>
	        			<Grid item xs={12}>
			      			<Grid container spacing={2}>
			        			<Grid item xs={2}>
					     		</Grid>
			        			<Grid item xs={8}>
									<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
										<Box  style={{textAlign: "justify", color: "#000", paddingBottom: "20px"}}>					
											<p class="altFliessText" style={{margin: 0}}>{t("immobilienverkaufBewertung")}</p>
										</Box>
										<center>		
										<Button onClick={e => callUrl("/immobilienbewertung")} variant="contained">Informieren</Button>                	
										</center>		

									</Box>	
					     		</Grid>
			        			<Grid item xs={2}>
					     		</Grid>
				     		</Grid>
			     		</Grid>
					</Box>
   				</Box>
   		</>
   	)
}

export default function StartPage(props) {

  return <StartContent props={props}/>;
}